// Framework
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
// Project modules
import { ShareModule } from "@src/app/modules/share/share.module";
import { PrivacyPolicyRoutingModule } from "./privacy-policy-routing.module";
// Components
import { PrivacyPolicyComponent } from "./components/privacy-policy/privacy-policy.component";

@NgModule({
    declarations: [
        PrivacyPolicyComponent,
    ],
    imports: [
        CommonModule,
        PrivacyPolicyRoutingModule,
        ShareModule,
    ]
})
export class PrivacyPolicyModule { }
